import "./App.css";
import { NotificationsComponent } from "./components/Notifications";
import { FooterComponent } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <NotificationsComponent />
      <FooterComponent />
    </div>
  );
}

export default App;
